import cs from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { MenuItem } from '@/Module/DefaultLayout/Constant/MENU_ITEMS';
import { useAppDispatch } from '@/Module/Store/Hook';
const LoggedInHeaderDesktop = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  return <div className="flex items-center justify-start gap-5" data-sentry-component="LoggedInHeaderDesktop" data-sentry-source-file="LoggedInHeaderDesktop.tsx">
      {MenuItem.map(item => <button key={item.key} type="button" onClick={async () => {
      await dispatch(authSetIsTransitioningAction(true));
      router.push(item.href);
    }} className={cs('flex items-center text-base font-bold text-blueSix py-3 px-4 rounded-xl gap-2', `${`${router.pathname}/` === item.href ? 'bg-blueOne' : 'bg-none'}`)}>
          {`${router.pathname}/` === item.href ? <item.iconActive size="small" className="text-blueTwo" /> : <item.iconUsual size="small" />}
          {item.title}
        </button>)}
    </div>;
};
export default React.memo(LoggedInHeaderDesktop);